module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-picker-field-widget"
  }, [_c('div', [_c('filter-field-widget', {
    attrs: {
      "field": _vm.filter
    },
    on: {
      "change-color-filter-values": _vm.filterUpdated
    }
  }), _vm._l((_vm.colorAFormated.range), function(range, rangeKey) {
    return (_vm.rangeIsNotEmpty(_vm.colorAFormated, rangeKey)) ? _c('div', [_c('div', {
      staticClass: "range-color-header-parts"
    }, [_c('span', {
      staticClass: "range-color-header-part title",
      domProps: {
        "textContent": _vm._s(range.label)
      }
    }), _c('span', {
      staticClass: "range-color-header-part"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(range.priceindicator)
      }
    }), _vm._l((range.picto), function(picto) {
      return _c('img', {
        staticClass: "picto",
        attrs: {
          "src": picto
        }
      })
    })], 2), (_vm.isThisRange(_vm.colorASelectedSummary, rangeKey)) ? _c('span', {
      staticClass: "range-color-header-part color-summary",
      domProps: {
        "textContent": _vm._s(_vm.colorASelectedSummary.label)
      }
    }) : _vm._e()]), _c('div', _vm._l((_vm.colorByRangekey(_vm.colorAFormated, rangeKey)), function(color, colorKey) {
      return (_vm.isVisible(colorKey, _vm.colorAFormated)) ? _c('label', {
        staticClass: "round-color-input",
        attrs: {
          "title": color.label,
          "for": ("colorA_" + colorKey)
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.colorASelected),
          expression: "colorASelected"
        }],
        attrs: {
          "type": "radio",
          "name": "colorA",
          "id": ("colorA_" + colorKey),
          "disabled": color.outOfStock
        },
        domProps: {
          "value": colorKey,
          "checked": _vm._q(_vm.colorASelected, colorKey)
        },
        on: {
          "change": function($event) {
            _vm.colorASelected = colorKey
          }
        }
      }), _c('div', {
        staticClass: "img",
        class: {
          'selected': (_vm.colorASelected === colorKey && !color.outOfStock)
        },
        style: ({
          'background': _vm.colorPictureStyleBackground(color.imageUrl, color.outOfStock)
        })
      })]) : _vm._e()
    }))]) : _vm._e()
  })], 2), (_vm.cc.config_1.product_reference !== 'PRD-14_store-californien') ? _c('div', {
    staticClass: "another-color-container"
  }, [(_vm.isTwoColorType) ? _c('div', {
    staticClass: "add-more-color",
    on: {
      "click": function($event) {
        _vm.changeColorType(_vm.threeColorType)
      }
    }
  }, [_c('span', {
    staticClass: "add-more-color-text",
    domProps: {
      "textContent": _vm._s(_vm.frText.abTest.prd14.variationB.fields.colorPicker.addColorPrefix)
    }
  }), _c('span', {
    staticClass: "add-more-color-text-alt",
    domProps: {
      "textContent": _vm._s(_vm.frText.abTest.prd14.variationB.fields.colorPicker.addColorColorCSuffix)
    }
  })]) : _vm._e(), (_vm.isThreeColorType) ? _c('div', {
    staticClass: "remove-one-color"
  }, [_c('div', {
    staticClass: "remove-one-color-text",
    domProps: {
      "textContent": _vm._s(_vm.frText.abTest.prd14.variationB.fields.colorPicker.removeColorCLeftButton)
    },
    on: {
      "click": function($event) {
        _vm.changeColorType(_vm.twoColorType)
      }
    }
  }), _c('div', {
    staticClass: "remove-one-color-text-alt",
    domProps: {
      "textContent": _vm._s(_vm.frText.abTest.prd14.variationB.fields.colorPicker.removeColorRightButton)
    },
    on: {
      "click": function($event) {
        _vm.changeColorType(_vm.twoColorType)
      }
    }
  }), (_vm.checkColorErrors('colorisC')) ? _c('div', {
    staticClass: "remove-one-color-text-subtitle color-picker-summary-value-error fp-error--excl",
    domProps: {
      "innerHTML": _vm._s(_vm.checkColorErrors('colorisC'))
    }
  }) : _vm._e(), _c('div', {
    staticClass: "remove-one-color-text-subtitle"
  }), _vm._l((_vm.colorCFormated.range), function(range, rangeKey) {
    return (_vm.rangeIsNotEmpty(_vm.colorCFormated, rangeKey)) ? _c('div', [_c('div', {
      staticClass: "range-color-header-parts"
    }, [_c('span', {
      staticClass: "range-color-header-part title",
      domProps: {
        "textContent": _vm._s(range.label)
      }
    }), _c('span', {
      staticClass: "range-color-header-part"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(range.priceindicator)
      }
    }), _vm._l((range.picto), function(picto) {
      return _c('img', {
        staticClass: "picto",
        attrs: {
          "src": picto
        }
      })
    })], 2), (_vm.isThisRange(_vm.colorCSelectedSummary, rangeKey)) ? _c('span', {
      staticClass: "range-color-header-part color-summary",
      domProps: {
        "textContent": _vm._s(_vm.colorCSelectedSummary.label)
      }
    }) : _vm._e()]), _c('div', _vm._l((_vm.colorByRangekey(_vm.colorCFormated, rangeKey)), function(color, colorKey) {
      return (_vm.isVisible(colorKey, _vm.colorCFormated)) ? _c('label', {
        staticClass: "round-color-input",
        attrs: {
          "title": color.label,
          "for": ("colorC_" + colorKey)
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.colorCSelected),
          expression: "colorCSelected"
        }],
        attrs: {
          "type": "radio",
          "name": 'colorC',
          "id": ("colorC_" + colorKey),
          "disabled": color.outOfStock
        },
        domProps: {
          "value": colorKey,
          "checked": _vm._q(_vm.colorCSelected, colorKey)
        },
        on: {
          "change": function($event) {
            _vm.colorCSelected = colorKey
          }
        }
      }), _c('div', {
        staticClass: "img",
        class: {
          'selected': (_vm.colorCSelected === colorKey)
        },
        style: ({
          'background': _vm.colorPictureStyleBackground(color.imageUrl, color.outOfStock)
        })
      })]) : _vm._e()
    }))]) : _vm._e()
  })], 2) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-116066a6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@oliverstore/core-rendering-engine/src/views/rendering_unit/abTest/ColorPickerFieldWidget.vue
// module id = 327
// module chunks = 1